export const AXP_CLIENT_FAAS_API_DOMAIN = 'faasApiUrl';
export const AXP_CLIENT_ENVIRONMENT = 'clientEnvironment';
export const AXP_CLIENT_BOOKING_SERVICE_API_URL = 'bookingServiceApiUrl';
export const AXP_CLIENT_EWP_BOOKING_SERVICE_API_URL = 'ewpBookingServiceApiUrl';
export const AXP_CLIENT_BACKEND_CANCEL_API_URL = 'backendCancelApiUrl';
export const AXP_CLIENT_BACKEND_MODIFICATION_API_URL = 'backendModificationApiUrl';
export const AXP_CLIENT_EWP_BACKEND_MODIFICATION_API_URL = 'ewpBackendModificationApiUrl';
export const AXP_CLIENT_LXP_AIR_EXCHANGE_REDIRECTION_URL_DOMAIN = 'airExchangeRedirectionUrlDomains';
export const AXP_CLIENT_ONE_CMS_INTRANET_BASE_URL = 'oneCmsIntranetBaseUrl';
export const AXP_CLIENT_ONE_CMS_INTERNET_BASE_URL = 'oneCmsInternetBaseUrl';
export const AXP_CLIENT_ONE_CMS_INTERNET_BASE_URL_STAR_VR = 'oneCMSInternetBaseUrl';
export const ONE_CLIENT_HOME_API_URL = 'travelHomeApiUrl';
export const AXP_CLIENT_BENEFITS_BASE_URL = 'benefitsBaseUrl';
export const AXP_CLIENT_APIGEE_API_DOMAIN = 'apigeeApiDomain';
export const AXP_CLIENT_EWP_API_DOMAIN = 'ewpApiDomain';
export const AXP_CLIENT_ONE_LOGIN_DOMAIN = 'oneLoginDomain';
export const AXP_CLIENT_AKAMAI_DOMAIN = 'akamaiDomain';
export const AXP_CLIENT_DATA_CONTROLLER_API = 'dataControllerApiUrl';
export const AXP_CLIENT_CHANGE_RESERVATION_API = 'changeReservationApiUrl';
export const AXP_CLIENT_ONE_CMS_INTERNET_SSRBASE_URL = 'oneCMSInternetSSRBaseUrl';
export const ONE_XP_API_URL = 'experimentsApiUrl';
